import EmBreve from '@/components/EmBreve';

export default function PacientesPage() {
  return (
    <EmBreve
      titulo="Pacientes"
      descricao="Base de pacientes em tratamento do espaço Recepção."
      secaoPlano="5.4"
    />
  );
}
